import { createEventBus } from 'n8n-design-system';

export const nodeViewEventBus = createEventBus();
